import { sendLead } from '~/assets/js/services/event-tracker'

export default function submitInterests ({
  leadEmail,
  leadName,
  leadOrigin,
  leadSubscriptionType,
}) {
  sendLead({
    leadOrigin,
    leadEmail,
    leadName,
    leadSubscriptionType,
  })
}
